module.exports = __webpack_public_path__ + "95b97efa98f9e3fb869bc9634c43a0cc.ttf";